<template>
  <SfModal
    v-if="modalOpen"
    content-class-name="sf-pad-3"
    size="m"
    @close="close"
  >
    <template #title>{{
      I18n.t('reports.subnav.analytical_dimensions')
    }}</template>

    <template #body>
      <div class="sf-grid sf-grid-fluid">
        <div class="sf-row">
          <div
            v-for="(dimensionType, index) in formattedDimensions"
            :key="`${dimensionType.number}-${index}`"
            class="sf-col tw-pb-3"
          >
            <div class="sf-title sf-pad-l-3 sf-below-2">
              {{
                I18n.t('ledger_import.columns.analytical_dimension_x', {
                  dimension: dimensionType.number + 1,
                })
              }}
            </div>
            <div
              class="sf-tab sf-overflow-scroll"
              style="max-height: calc(100vh - 500px)"
            >
              <div
                v-for="dimension in dimensionType.dimensions"
                :key="dimension.id"
                class="sf-tab-item"
              >
                <SfCheckbox
                  v-model="dimension.checked"
                  :label="dimension.reference"
                ></SfCheckbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <SfButtonDs
        v-if="editDimensionsUrl"
        variant="secondary"
        :href="editDimensionsUrl"
        >{{ I18n.t('dimension.edit') }}</SfButtonDs
      >
      <SfButtonDs variant="secondary" @click="close">{{
        I18n.t('reports.subnav.cancel')
      }}</SfButtonDs>
      <SfButtonDs variant="primary" @click="apply">{{
        I18n.t('reports.subnav.apply')
      }}</SfButtonDs>
    </template>
  </SfModal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import { SfCheckbox, SfButtonDs } from '@silverfin/ui-components'

import { deleteQueryParam, setQueryParams } from '../../../utils/url-helpers'

import { RENDER_PARAM } from '@app/application/report/constants'

export default {
  components: {
    SfModal,
    SfCheckbox,
    SfButtonDs,
  },

  data() {
    return {
      modalOpen: false,
      formattedDimensions: [],
    }
  },

  methods: {
    openModal(context) {
      this.formattedDimensions = context.formattedDimensions
      this.editDimensionsUrl = context.editDimensionsUrl
      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    apply() {
      const selectedDimensionList = {}
      this.formattedDimensions.forEach((dimensionType) => {
        dimensionType.dimensions.forEach((dimension) => {
          selectedDimensionList[`selected_dimensions[${dimension.id}]`] =
            dimension.checked ? 1 : undefined
        })
      })

      setQueryParams(selectedDimensionList)
      deleteQueryParam(RENDER_PARAM)
      Turbolinks.visit(window.location.href)
    },
  },
}
</script>
